/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Setting_IrlInputs */



/**
* | output |
* | --- |
* | "In person" |
*
* @param {Tournament_Wiz_Setting_IrlInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_setting_irl = /** @type {((inputs?: Tournament_Wiz_Setting_IrlInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Setting_IrlInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En présentiel")
	if (locale === "es") return /** @type {LocalizedString} */ ("Presencial")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Presencial")
	if (locale === "it") return /** @type {LocalizedString} */ ("Di persona")
	return /** @type {LocalizedString} */ ("In person")
});